import { render, staticRenderFns } from "./SendInvoicesEmail.vue?vue&type=template&id=f460d5e4&scoped=true"
import script from "./SendInvoicesEmail.vue?vue&type=script&lang=js"
export * from "./SendInvoicesEmail.vue?vue&type=script&lang=js"
import style0 from "./SendInvoicesEmail.vue?vue&type=style&index=0&id=f460d5e4&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f460d5e4",
  null
  
)

export default component.exports